import React from 'react';
import { getSettingsClass } from '~/utils/helpers';
import { FeaturesGrid } from './FeaturesGrid';
import { graphql } from 'gatsby';

const FeaturesGridBlock: React.FC<{ block: FeaturesGrid }> = ({ block }) => {
  const settingsClass = getSettingsClass(block.settings);

  return (
    <div
      className={`block__features_grid flex h-fit w-full justify-center ${settingsClass}`}
    >
      <FeaturesGrid
        settings={block.settings}
        rounded_corners={block.rounded_corners}
        content_alignment={block.content_alignment}
        features_grid={block.features_grid}
      />
    </div>
  );
};

export default FeaturesGridBlock;

export const query = graphql`
  fragment FeaturesGridFragment on Block {
    settings {
      ...SettingsFragment
    }
    content_alignment
    rounded_corners
    features_grid {
      visibility
      offset_top
      padding_bottom
      size_type
      icon {
        src
        size
      }
      template_pretitle {
        ...TextTemplateFragment
      }
      template_title {
        ...TextTemplateFragment
      }
      template_text {
        ...TextTemplateFragment
      }
      border_settings {
        ...BorderTemplateFragment
      }
      background_color
      image {
        src
        alt
        position
        image_max_width
        image_max_height
      }
    }
  }
`;
